import districtsByCity from "./trDistrictsByCity.generated.json";

/**
 * İl listesi (Türkçe sıra). Veri: TurkiyeAPI — `scripts/fetch-tr-locations.mjs` ile güncellenir.
 * @see https://docs.turkiyeapi.dev/tr/v1/guide/districts.html
 */
export const TR_CITIES = Object.keys(districtsByCity).sort((a, b) =>
  a.localeCompare(b, "tr", { sensitivity: "base" })
);

export const TR_DISTRICTS_BY_CITY = districtsByCity;

export function getDistrictsForCity(city) {
  return TR_DISTRICTS_BY_CITY[city] || [];
}
